import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts(
  'health-board',
  'complete-care-plan-task',
  ['START'],
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'todo',
  type: 'put',
  slug: [
    'care_plan_tasks',
    {
      type: 'payload',
      selector: ['task_id'],
    },
  ],
});

export default createReqReducer(consts, true);



// WEBPACK FOOTER //
// ./src/redux/healthboard/requests/complete-care-plan-task-req.js